<template>
    <div class="d-flex">
        <div class="avatar-cont mr-2" style="margin-left: -32px">
            <PersonAvatar :size="24" :person="item.sender" />
        </div>
        <div class="fill-width">
            <div
                v-if="item.status !== 'sent'"
                class="overflow-y-auto rounded-lg py-1 px-2 w-100 d-inline-block error lighten-2 "
            >
                <div
                    class="d-flex align-center cursor-pointer"
                    @click="isEmailLogDialogOpen = true"
                >
                    <icon
                        size="18"
                        color="error"
                        icon="AlertTriangle"
                    />
                    <div class="ml-2 subtitle-2 error--text">
                        {{ item.status === 'failed' ? $t('Email not delivered') : $t('Sent, but fallback to Uku email') }}
                    </div>
                </div>
            </div>
            <div class="activity-row">
                <span
                    :class="['comment-name font-weight-medium', current_account.id === item.sender_id ? 'me' : '']"
                >
                    {{ item.sender | format_name }}
                </span>
                <span class="comment-type">
                    {{ taskLogType }}
                    <span class="n5--text subtitle-2 font-weight-bold cursor-pointer text-decoration-underline" @click="isEmailLogDialogOpen = true">”{{ item.msg.Subject }}”</span>
                </span>
            </div>
            <Footer
                :created_at="item.created_at"
            />
        </div>
        <EmailLogDialog
            v-if="isEmailLogDialogOpen"
            :client-id="item.client_id"
            :email-log-id="item.id"
            @close="isEmailLogDialogOpen = false"
        />
    </div>
</template>

<script>
import {$t} from "@/i18n";
import PersonAvatar from "../../../../components/PersonAvatar";
import AccountModule from "../../../../store/modules/account";
import TaskEditCommentControl from "../../TaskEditCommentControl";
import {ref, computed} from "@vue/composition-api";
import {TASK_LOG_TYPE} from "../../../../helpers/constants";
import Footer from "../Footer.vue"
import EmailLogDialog from "@/components/Emailing/EmailLogDialog/Index.vue";

export default {
    name: "EmailLogRow",
    components: {
        PersonAvatar,
        TaskEditCommentControl,
        Footer,
        EmailLogDialog
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    setup(props, ctx) {
        const isEmailLogDialogOpen = ref(false)
        const { current_account } = AccountModule();

        const taskLogType = computed(() => {
            if (props.item.status === 'failed') {
                return $t('failed to send')
            } else if (props.item.status === 'sent') {
                return $t('sent email')
            } else if (props.item.status === 'warning') {
                return $t('sent email')
            }

            return '-'
        })

        return {
            current_account,
            taskLogType,
            isEmailLogDialogOpen
        }
    }
}
</script>

<style scoped>

</style>